<template>
    <auto-complete-search
        v-model="id"
        :type="'account'"
        :label="$t(label)"
        :items.sync="activeAccounts"
        :error="field.account.error"
        :rules="rules"
        :error-message="field.account.message"
        @resetError="clearFieldMessageAccount"
        @update:search-input="fetchAccountsData"
        :hideDetail="false"
        :loading="loading">
    </auto-complete-search>
</template>
<script>

import { mapActions, mapState } from 'vuex';
import AutoCompleteSearch from '../common/AutoCompleteSearch.vue'
export default {
  components: { AutoCompleteSearch },
    name: 'AccountSearch',
    props: {
        value: Number,
        rules: Array,
        idAccount: Number,
        label: {
            type: String,
            default: 'account_name'
        }
    },
    data() {
        return {
            loading: false,
            activeAccount: [],
            field: {
                account: {
                    message: '',
                    error: false
                }
            }
        }
    },
    computed: {
        ...mapState('accounting/activeAccount', ["activeAccounts"]),
        id: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    watch: {
        // id: {
        //     handler() {
        //         if(this.id) {
        //             let name = this.activeAccounts.find(each => each.id == this.id).displayName;
        //             this.$emit('update:name', name);
        //         } 
        //     }
        // }
    },
    methods:{
        ...mapActions('accounting/activeAccount', ["fetchActiveAccounts", "fetchActiveAccount", "setActiveAccounts"]),
        async fetchAccountsData(val) {
            this.loading = true;
            this.clearFieldMessageAccount();
            let result = await this.fetchActiveAccounts({ search: val });
            if(result.data.length == 0) {
                this.setMessageAccount("Your search didn't match any record!");
            }
            this.loading = false;
        },
        setMessageAccount(val) {
            this.field.account.error = true;
            this.field.account.message = val;
        },
        async fetchAccountData(val) {
            console.log('val', val)
            if(val != null) {
                this.loading = true;
                this.clearFieldMessageAccount();
                this.fetchActiveAccount(val).then(async (respone) => {
                    if(respone.data.length == 0) {
                        this.setMessageAccount("Your search didn't match any record!");
                    }else {
                        this.activeAccount = this.activeAccount.concat(respone.data);
                        await this.setActiveAccounts(this.activeAccount);
                    }

                });
                this.loading = false;
            }
        },
        clearFieldMessageAccount() {
            this.field.account.error = false;
            this.field.account.message = '';
        },
    },
    created() {
        if(this.value) this.fetchAccountData(this.value);
    }
}
</script>

<style>

</style>